<template>
	<div class="infor fl">
		<div class="infor-t clearfix" @click="onChangeTap">
			<div class="fl infor-t-l">{{addShow?'项目管理':'新增项目展示'}}</div>
			<div class="fr infor-t-r">
				<img v-if="addShow" src="../assets/bianji.png" alt="" />
				<span>{{addShow?'新增项目展示':'取消并返回'}}</span>
			</div>
		</div>
		<div v-if="addShow" class="">
			<div class="listcontainer">
				<div v-for="(item,index) in list" :key="index" class="imgcontaiuner" @click="getimg(item)">
					<div class="pos-relative-img">
						<img :src="item.img_url" alt="">
						<div class="block-hover">
							<div class="blokc-hover-b" @click.stop="onRemoverTap(item.id)">
								删除
							</div>
						</div>
					</div>
					<span>{{item.title}}</span>

				</div>
			</div>
			<Pagetion :total="total" @getpageValue="getpageValue" :page-size="pageSize" class="pos-page" />
			<el-dialog :close-on-click-modal="false" :title="shoeitem.title" :visible.sync="dialogVisible" width="40%">
				<el-image style="width:100%;" :src="shoeitem.img_url" fit="contain"></el-image>
			</el-dialog>
		</div>
		<div v-if="!addShow" class="">
			<el-form :label-position="labelPosition" size="small" label-width="120px" class="demo-ruleForm">
				<el-form-item label="项目的标题" class="inpyabeb font-title">
					<el-input v-model="form.title" placeholder="请输入项目的标题文字"></el-input>
				</el-form-item>

				<div class="flex-w">
					<div class="flex-w-l font-title">项目照片</div>
					<el-upload ref='upload' :action="$baseURL+'/api/home/upload/file/prize'"
						accept=".jpg, .png" :data="{token:token}" list-type="picture-card" :limit="limit"
						:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleAdd"
						:on-exceed="handleExceed" :on-change="handleEditChange">
						<i class="el-icon-plus"></i>
					</el-upload>
					<div class="">
						<el-dialog :visible.sync="dialogVisible" class="poto">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div>
				</div>
				<el-form-item class="margin-left-50">
					<el-button type="primary" icon="el-icon-check" style="background-color:#194ABE" size="small"
						class="block-submit" @click="onSubmit">保存修改
					</el-button>
				</el-form-item>
			</el-form>

		</div>
		<!-- 删除弹窗 -->
		<!-- 	<el-dialog title="提示" :visible.sync="dialogVisible_1" width="30%" :before-close="handleClose">
			<span>确定删除？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible_1 = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible_1 = false">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>

<script>
	// import AllHeader from '@/components/Modal/AllHeader'
	import Pagetion from '@/components/Modal/Pagetion'
	import {
		PrizeList,
		AddPrize, //新增奖项
		DelatePrize, //删除奖项
	} from "../utils/api.js"
	export default {
		name: "award",
		components: {
			// AllHeader,
			Pagetion
		},
		data() {
			return {
				token: '',
				labelPosition: 'right',
				shoeitem: {},
				total: 0,
				pageSize:12,
				addShow: true,
				dialogVisible: false,
				dialogVisible_1: false,
				list: [],

				form: {
					title: ''
				},
				// 上传的文件列表
				fileList: [],
				limit: 1,
				// 返回的图片
				imgUrl: '',
				// 照片
				dialogImageUrl: '',

			}
		},
		async mounted() {

			this.initList(1)
			this.token = 'Bearer ' + localStorage.getItem("TOKEN")
		},
		methods: {
			initList(page) {
				const data = {
					page_size: this.pageSize,
					page: page,
				}
				PrizeList(data).then(res => {
					console.log(res.total)
					this.list = res.data
					this.total = res.total
				})
			},
			onChangeTap() {
				this.addShow = !this.addShow
				console.log(this.addShow)
			},
			getpageValue(index) {
				console.log(index)
				this.initList(index)
			},
			getimg(row) {
				this.shoeitem = row;
				this.dialogVisible = true;
				console.log(row)
			},
			handleAdd(response, file, fileList) {
				console.log(response)
				console.log(file, fileList);
				this.fileList = fileList
				this.imgUrl = response.data.host + response.data.url
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},

			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleExceed() {

				this.$message.warning(`请最多上传 ${this.limit} 个文件。`);
			},
			// 图片数量大于五  变量为true 控制隐藏上传按钮
			handleEditChange(file, fileList) {
				console.log(fileList)
				this.hideUploadEdit = fileList.length >= 1

			},
			// 删除
			onRemoverTap(id) {

				DelatePrize(id).then(res => {
					console.log(res)
					this.$message.success(`删除成功`);
					let list = this.list
					list.map((item, index) => {
						if (item.id == id) {
							list.splice(index, 1);
						}
					})
					this.list = list
				})

			},
			// 新增奖项提交
			onSubmit() {
				if (!this.form.title) {
					this.$message({
						showClose: true,
						message: '请输入项目的标题',
						type: 'warning'
					});
					return
				} else if (!this.imgUrl) {
					this.$message({
						showClose: true,
						message: '请上传图片',
						type: 'warning'
					});
				} else {
					console.log('提交')
					const data = {
						title: this.form.title,
						img_url: this.imgUrl
					}
					AddPrize(data).then(res => {
						console.log(res)
						// 清空数据
						this.form.title = ''
						this.fileList = []
						console.log(this.fileList)
						this.$refs.upload.clearFiles();
						this.initList()
						this.imgUrl = ''
						this.$message({
							showClose: true,
							message: '添加成功',
							type: 'success'
						});
					}).catch(err => {
						this.$message.error(err);
					})
				}

			},
		}

	}
</script>

<style lang="less" scoped>
	/deep/.el-upload-none {
		display: none;
		text-align: center;
		cursor: pointer;
		outline: 0;
	}

	.demo-ruleForm {


		.inpyabeb {
			width: 50%;
			padding-left: 100px;
			margin-top: 50px;
		}
	}



	.font-title {
		color: #71767C;
	}

	.margin-left-50 {
		margin-left: 50px;
	}

	.block-submit {
		width: 189px;
		height: 50px;
		background: #194ABE;
		opacity: 1;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		margin-top: 37px;
	}

	.flex-w {
		display: flex;
		// align-items: center;
		justify-content: left;
		padding-left: 140px;
		padding-bottom: 100px;
		border-bottom: 2px solid #E51725;

		&-l {
			margin-right: 13px;
		}
	}

	.infor {
		width: 858px;
		height: 800px;
		padding: 0px 30px 40px 30px;
		background: #fff;
		border-radius: 6px;
		margin-left: 14px;
		margin-bottom: 34px;
		position: relative;

		&-t {
			// padding: 14px;
			padding-top: 14px;
			border-bottom: 1px solid #D4DBDD;

			&-l {
				font-size: 28px;
				color: #181e23;
				display: inline-block;
				padding-bottom: 14px;
				font-weight: bold;
				// border-bottom: 2px solid #194abe;
			}

			&-r {
				width: 140px;
				height: 31px;
				background: #E51725;
				opacity: 1;
				overflow: hidden;
				display: table-cell;
				line-height: 31px;
				border-radius: 6px;
				cursor: pointer;

				img {
					vertical-align: middle;
					margin-right: 6px;
				}

				span {
					color: #FFFFFF;
					font-size: 14px;
				}
			}
		}

		&-c {
			text-align: justify;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 32px;
			color: #565656;
			padding: 10px 0px;
		}

		&-img {
			text-align: center;
			padding: 24px 0px 40px 0px;
		}


	}

	.listcontainer {
		// display: flex;
		// flex-wrap: wrap;
		overflow: hidden;
		margin-right: -12px;

		margin-top: 0;
		margin-bottom: 29px;

		.imgcontaiuner {
			float: left;
			width: 204px;
			margin-right: 12px;
			margin-bottom: 12px;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 16px;
			color: #0C0D0F;
			margin-bottom: 10px;
			cursor: pointer;
			// margin-right: 12px;
			margin-top: 35px;

			img {
				width: 204px !important;
				height: 154px !important;
				height: auto;
			}
		}

		.pos-relative-img {
			position: relative;


		}

		.pos-relative-img:hover>.block-hover {
			display: block;

		}
	}

	.block-hover {
		display: none;
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		background: rgba(0, 0, 0, .55);
		z-index: 1000;
		justify-content: center;
		align-items: center;
		margin: 0 auto;

		.blokc-hover-b {
			width: 65px;
			height: 26px;
			background: rgba(12, 13, 15, 0.4);
			border: 1px solid #FFFFFF;
			opacity: 1;
			border-radius: 4px;
			color: #FFFFFF;
			font-size: 12px;
			margin: 0 auto;
			margin-top: 70px;
			text-align: center;
			line-height: 26px;
		}
	}

	.pos-page {
		position: absolute;
		bottom: 30px;
		width: 100%;
	}
</style>
